var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/anonymous/Desktop/components/BottomLink.js",
  _this = this;
import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@wds/box';
import { Button } from '@wds/button';
import { IconArrowRight } from '@wds/icons';
export var BottomLink = function BottomLink(_ref) {
  var title = _ref.title,
    url = _ref.url,
    alignment = _ref.alignment;
  return /*#__PURE__*/React.createElement(Box, {
    className: "sm-nav-submenu__button",
    style: {
      float: alignment
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    color: "link",
    variant: "text",
    href: url,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Box, {
    element: "span",
    display: "flex",
    gap: 2,
    alignItems: "center",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 9
    }
  }, title, /*#__PURE__*/React.createElement(IconArrowRight, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 11
    }
  }))));
};
export default BottomLink;
BottomLink.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  alignment: PropTypes.string.isRequired
};
//# sourceMappingURL=BottomLink.js.map